import { ArchBaseService } from "@/common/api.service";
import {
  GET_NOTIFICATION_TYPES,
  GET_NOTIFICATION_ACTIONS,
  GET_NOTIFICATION_TEMPLATES,
  SEND_REMITTER_NOTIFICATION,
  GET_REMITTER_NOTIFICATION_LOGS,
} from "./actions.type";
import { ISLOADING } from "./mutations.type";

const state = {};
const getters = {};

const actions = {
  async [GET_NOTIFICATION_TYPES]() {
    ArchBaseService.init();
    return new Promise((resolve) => {
      ArchBaseService.get("notifications/types", {})
        .then((data) => resolve(data))
        .catch(({ response }) => resolve(response));
    });
  },

  async [GET_NOTIFICATION_ACTIONS]() {
    ArchBaseService.init();
    return new Promise((resolve) => {
      ArchBaseService.get("notifications/actions", {})
        .then((data) => resolve(data))
        .catch(({ response }) => resolve(response));
    });
  },

  // Pre-set notifications a CE agent may pick from. Only admin-composable
  // templates come back; the automatic ones are fired by the backend and are
  // deliberately not offered here.
  async [GET_NOTIFICATION_TEMPLATES]() {
    ArchBaseService.init();
    return new Promise((resolve) => {
      ArchBaseService.get("notifications/templates", {})
        .then((data) => resolve(data))
        .catch(({ response }) => resolve(response));
    });
  },

  async [SEND_REMITTER_NOTIFICATION](context, payload) {
    ArchBaseService.init();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      ArchBaseService.post("notifications/remitter", payload)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  async [GET_REMITTER_NOTIFICATION_LOGS](context, payload = {}) {
    ArchBaseService.init();
    return new Promise((resolve) => {
      ArchBaseService.get("notifications/logs/remitter", payload)
        .then((data) => resolve(data))
        .catch(({ response }) => resolve(response));
    });
  },
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations,
};
